module.exports = __webpack_public_path__ + "img/icon9.3ca8ebf9.png";